/* global Parse */

import React from 'react';
import { Menu, Container, Dropdown } from 'semantic-ui-react';
import { useNavigate, Outlet } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

function Protected() {
  const navigate = useNavigate();

  const handleItemClick = (e, {value}) => {
    switch (value) {
    case 'sun':
      navigate('/protected');
      break;
    case 'heatMap':
      navigate('/protected/heatmap');
      break;
    case 'fogMap':
      navigate('/protected/fogmap');
      break;
    case 'moon':
      navigate('/protected/moon');
      break;
    case 'help':
      window.location.assign('http://www.escaype.com/help')
      break;
    case 'memberArticles':
      window.location.assign('http://www.escaype.com/testapp')
      break;
    default:
      console.warn(value); // eslint-disable-line no-console
    }
  }

  return (
    <div style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
      <Menu inverted style={{flexShrink: 0, borderRadius: 0}}>
        <Container>
          <Menu.Item header>
            <img className='logo' src='/images/escaypeLogo3.png' height='35px' width='35px' alt='escaype logo' style={{marginRight: '1.5em'}} />
            Escaype
          </Menu.Item>
          <Dropdown item text='Menu'>
            <Dropdown.Menu>
              <Dropdown.Item icon='sun' text='Sun' value='sun' onClick={handleItemClick} />
              <Dropdown.Item icon='map' text='Heat Map' value='heatMap' onClick={handleItemClick} />
               <Dropdown.Item icon='map' text='Fog Map' value='fogMap' onClick={handleItemClick} />
              <Dropdown.Item icon='help' text='Help' value='help' onClick={handleItemClick} />
              <Dropdown.Item icon='file text outline' text='Member Articles' value='memberArticles' onClick={handleItemClick} />
            </Dropdown.Menu>
          </Dropdown>
          <Menu.Item icon='sign out'name='logOut' position='right' onClick={() => {
            Parse.User.logOut().catch(() => {}).then(() => {
              navigate('/login');
            });
          }} />
        </Container>
      </Menu>
      <div style={{/*backgroundColor: 'red', */display: 'flex', flex: '1 1 auto'}}>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </div>
    </div>
  );
}

export default Protected;